module.exports = __webpack_public_path__ + "img/inspiration-3@2x.fc7aa07.jpg";